import './App.css';
import { Toaster } from 'react-hot-toast';
import RoutesComponent from './RoutesComponent';

function App() {
  return (
    <div className="App">
     <RoutesComponent/>
     <Toaster position="top-right" toastOptions={{ duration: 4500 }} />
    </div>
  );
}

export default App;
